import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import LinkName from "../constants/linkName";
import utilsCommon from "../utils/common";
import LoginApi from "../api/Login";
import ModalTimeOut from "../components/Modal/ModalTimeOut";
import { useTranslation } from "react-i18next";
import constantsStorage from "../constants/storage";
import Constants from "../constants/constants";
import ModalMessageConfirm from "../components/Modal/ModalMessageConfirm";
import AlertOffline from "../components/AlertOffline";

/**
 * declare object
 */
let objLoginApi = null;

/**
 * check condition to render
 * 
 * @param {Object} param
 * @returns component
 */
function ConditionalRenderer({
    component: Component,
    routeProps
}) {

    //define state
    const [ t ] = useTranslation();
    
    const tokenLogin = utilsCommon.getAccessToken();
    const isLocalStorageCookieAvailable =  utilsCommon.isLocalStorageCookieAvailable();
    const sessionFromLocalStorage = utilsCommon.getStorageDataByKey(constantsStorage.SESSION);
    const sessionDataLoginFromLocalStorage = utilsCommon.getStorageDataByKey(constantsStorage.SESSION_DATA_LOGIN);
    const isTeacher = utilsCommon.getStorageDataByKey(constantsStorage.USER)?.isTeacher;
    
    const [modalTimeOut, setModalTimeOut] = useState(false);
    const [modalEndTime, setModalEndTime] = useState(false);
    const [confirmLogout, setConfirmLogout] = useState(false);
    const [isLogout, setLogout] = useState(false);

    //state session time
    const endTimeOut = sessionFromLocalStorage.timeout;
    const endTimeLogOut = sessionFromLocalStorage.timeLogout;

    //state end time api
    const endTimeOutApi = sessionDataLoginFromLocalStorage.timeout;
    const endTimeLogOutApi = sessionDataLoginFromLocalStorage.timeLogout;


    //control display modal
    const toggleModalTimeOut = () => {
        setModalTimeOut(!modalTimeOut);
    }

    //control display modal
    const toggleModalEndTime = () => {
        setModalEndTime(!modalEndTime);
    }

    /**
     * check time login
     */
    useEffect(() => {
        let sessionType = Constants.SESSION_TYPE.DEFAULT;
        const timer = setInterval(() => {
            const now = new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Tokyo"})).getTime();
            if (now >= endTimeOut && sessionType !== Constants.SESSION_TYPE.LOCAL && sessionType !== Constants.SESSION_TYPE.API) {
                toggleModalTimeOut();
                sessionType = Constants.SESSION_TYPE.LOCAL;
            }
            if (now >= endTimeLogOut) {
                toggleModalTimeOut();
                setLogout(true);
            }
            if (!isTeacher) {
                if (now >= endTimeOutApi && sessionType !== Constants.SESSION_TYPE.LOCAL && sessionType !== Constants.SESSION_TYPE.API) {
                    toggleModalEndTime();
                    sessionType = Constants.SESSION_TYPE.API;
                }
                if (now >= endTimeLogOutApi) {
                    utilsCommon.executeLogout();
                }
            }
        }, 1000);

        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    // initial objects
    objLoginApi = objLoginApi || new LoginApi();

    utilsCommon.checkPullName();
    //check use localstorage and cookie
    if(!isLocalStorageCookieAvailable){
        return (
            <Redirect
                to={{
                    pathname: LinkName.ERROR_AVAILABLE,
                    state: { from: routeProps.location }
                }}
            />
        );
    }

    // check user login information
    if (!tokenLogin) {
        return <Redirect to={{ pathname: LinkName.LOGIN, state: { from: routeProps.location } }} />
    }

    if (tokenLogin && !modalTimeOut && !modalEndTime && navigator.onLine){
        async function checkLogin(){
            let checkParams = await utilsCommon.isCheckLogin(objLoginApi,tokenLogin);
            if(!checkParams){
                utilsCommon.executeLogout();
            }else{
                return;
            }
        }
        checkLogin();
    }

    // check has data menu
    if ([
        LinkName.MENU_TABLE,
        LinkName.MAIN,
        LinkName.NUTRIENTS_GRAPH
    ].includes(routeProps.location.pathname)) {
        const menuTableId = utilsCommon.getStorageDataByKey(constantsStorage.CONDITION_SETTING_MENU_TABLE_ID, utilsCommon.storageSession);
        if(!menuTableId){
            return <Redirect to={{ pathname: LinkName.TITLE }} />
        }
    }
    return (
        <>
        <Component {...routeProps} setConfirmLogout={setConfirmLogout}/>
        {
            modalTimeOut && !isLogout &&
                <ModalTimeOut 
                    modal = {modalTimeOut} 
                    toggle = {toggleModalTimeOut}
                    message ={t('MESSAGE_TIME_OUT')}
                    />
        }
        {
            modalTimeOut && isLogout &&
                <ModalTimeOut 
                    modal = {modalTimeOut} 
                    message ={t('MESSAGE_LOGOUT')}
                    callback = {() => utilsCommon.executeLogout()}
                    />
        }
        {
            modalEndTime && 
                <ModalTimeOut
                    modal = {modalEndTime}
                    toggle = {toggleModalEndTime}
                    message = {t('MESSAGE_END_TIME')}
                />
        }
        {
            <ModalMessageConfirm
                modal = {confirmLogout}
                toggle = {() => setConfirmLogout(false)}
                message = {t('MESSAGE_CONFIRM_LOGOUT')}
                callback = {() => utilsCommon.executeLogout()}
            />
        }
        <AlertOffline/>
        </>
    );
}

export default function ProtectedRoute({
    component: Component,
    ...restOfProps
}) {

    return (
        <Route
            {...restOfProps}
            render={(routeProps) => (
                <ConditionalRenderer
                    routeProps={routeProps}
                    component={Component}
                />
            )}
        />
    );
}
